import React, { PureComponent } from 'react';

import Category from './Category/';
import Filter from '../../src/components/Filter';
import PropTypes from 'prop-types';

class ShopList extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      ...this.hydrateState(props.shops)
    };
  }

  hydrateState = shops => {
    let items = {};
    const { type, category, t } = this.props;

    shops.forEach(shop => {
      let children = {};

      Object.values(shop.children).map(child => {
        if (category) {
          children[child.id] = child.categorySlug === category;
        } else if (type) {
          let value = null;
          switch (type) {
            case 'boutique':
            case 'boutiques':
            case 'shop':
            case 'shops':
              value = child.parentType === 'shop';
              break;
            case 'restaurant':
            case 'restaurants':
              value = child.parentType === 'restaurant';
              break;
            case 'bien-etre':
            case 'well-being':
              value = child.parentType === 'bien-etre';
              break;
            default:
              break;
          }
          children[child.id] = value;
        } else {
          children[child.id] = true;
        }
      });

      items[shop.id] = { ...children };
    });

    this.props.handleUpdateFilters(items);
    return items;
  };

  shouldRenderCategory = category => {
    if (!this.state[category]) {
      return true;
    }

    return Object.values(this.state[category]).find(filter => filter) || false;
  };

  toggleFilter = (filter, category) => {
    const item = {
      ...this.state[category],
      [filter]: !this.state[category][filter]
    };

    this.setState({ [category]: item });
    this.props.handleUpdateFilters({ ...this.state, [category]: item });
  };

  toggleCategory = category => {
    const items = { ...this.state[category] };
    for (let sub in items) {
      items[sub] = !this.shouldRenderCategory(category);
    }

    this.setState({ [category]: items });
    this.props.handleUpdateFilters({ ...this.state, [category]: items });
  };

  renderCategory = category => {
    const { id, label, children } = category;

    return (
      this.shouldRenderCategory(id) && (
        <Category
          key={id}
          label={label}
          items={Object.values(children)}
          filters={this.state[id]}
        />
      )
    );
  };

  renderCategories = () => this.props.shops.map(this.renderCategory);

  render() {
    const { t } = this.props;
    return (
      <div>
        <Filter
          title={t('common:brands.filters.title')}
          data={this.props.shops}
          filters={this.state}
          toggleFilter={this.toggleFilter}
          toggleCategory={this.toggleCategory}
        />
        {this.renderCategories()}
      </div>
    );
  }
}

ShopList.propTypes = {
  shops: PropTypes.array,
  type: PropTypes.string,
  category: PropTypes.string
};

export default ShopList;
